<template>
    <div>
        Delete account
    </div>
</template>